import { readImageUrl } from '../image-helper'

$(document).on('ready', function() {
  $('input[name="ticket_attributes[attachments_attributes][0][file]"]').on('change', function() {
    readImageUrl(this)
  })
})
